// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Payors_Content_Payors_Payor($where: vaxiom_payment_plans_bool_exp) {
  vaxiom_payment_plans(
    where: $where
    order_by: { transaction: { sys_created: desc } }
  ) {
    id
    transaction {
      id
    }
  }
}

`